import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import { EditorState, SelectionState, Modifier } from 'draft-js'
import CloseIcon from '../../../common/icons/CloseIcon2'
import EditorUtils from 'draft-js-plugins-utils'
import isUrlValid from '../../../common/helpers/isUrlValid'
import BlueLoadingButton from '../../../common/BlueLoadingButton'

const Container = styled.div`
  height: 197px;
  width: 466px;
  background-color: #FFFFFF;
  box-shadow: 0 2px 8px 0 #979797;
  box-sizing: border-box;
  padding: 25px 15px 15px 15px;
  position: relative;
`
const Title = styled.div`
  height: 22px;
  width: 85px;
  color: #6C6C70;
  font-family: "Open Sans", sans-serif;
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 0.25px;
  line-height: 22px;
`
const Row = styled.div`
  display: flex;
  justify-content: flex-end;
  width: 100%;
`
const Input = styled.input`
  height: 23px;
  width: 333px;
  border: 1px solid #979797;
  &:focus {
    border: 1px solid #979797;
    box-shadow: none !important;
  }
  width: 100%;
`
const Cancel = styled.div`
  height: 19px;
  width: 51px;
  color: #8B8D8F;
  font-family: "Open Sans";
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 0.36px;
  line-height: 19px;
  text-align: center;
  cursor: pointer;
  display: flex;
  align-items: center;
  margin-right: 20px;
`
const Buttons = styled.div`
  display: flex;
  width: 100%;
  justify-content: flex-end;
`
const CloseButton = styled.div`
  position: absolute;
  cursor: pointer;
  top: 15px;
  right: 15px;
`

export default class LinkModal extends React.Component {
  constructor(props) {
    super(props)
    const { editorState } = props

    this.state = {
      linkText: this.getSelectedText(editorState) || '',
      url: this.formatLink(this.getUrl(editorState) || '')
    }
  }

  static propTypes = {
    editorState: PropTypes.object.isRequired,
    toggleModal: PropTypes.func.isRequired
  }

  getSelectedText = editorState => {
    if(editorState === null) {
      return
    }
    const entity = EditorUtils.getCurrentEntity(editorState)
    const selectionState = editorState.getSelection()
    const anchorKey = selectionState.getAnchorKey()
    const currentContent = editorState.getCurrentContent()
    const currentContentBlock = currentContent.getBlockForKey(anchorKey)
    const length = currentContentBlock.getLength()

    return currentContentBlock.getText().slice(0, length)
  }

  getUrl = editorState => {
    if (editorState === null) {
      return
    }
    let url
    const currentEntity = EditorUtils.getCurrentEntity(editorState)

    if (currentEntity && currentEntity.type === 'LINK') {
      url = currentEntity.getData().url
    }
    return url
  }

  formatLink = link => {
    if (!link.includes('http://')) {
      return `http://${link}`
    }
    return link
  }

  onLinkRemove = () => {
    const { editorState } = this.state
    const newEditorState = EditorUtils.removeLinkAtSelection(editorState)

    updateEditorState(newEditorState)
  }

  onLinkCreate = () => {
    const { editorState, updateEditorState } = this.props
    const { url, linkText } = this.state
    // Get info about block with link
    const contentState = editorState.getCurrentContent()
    const selectionState = editorState.getSelection()
    const anchorKey = selectionState.getAnchorKey()
    const currentContent = editorState.getCurrentContent()
    const currentContentBlock = currentContent.getBlockForKey(anchorKey)
    const length = currentContentBlock.getLength()
    // Setup selection to replace with linkText
    const currentSelection = new SelectionState({ anchorKey, anchorOffset: 0, focusKey: anchorKey, focusOffset: length })
    const newContent = Modifier.replaceText(contentState, currentSelection, linkText)
    const editorState1 = EditorState.push(editorState, newContent, 'insert-characters')
    const editorState2 = EditorState.forceSelection(editorState1, new SelectionState({ anchorKey, anchorOffset: 0, focusKey: anchorKey, focusOffset: linkText.length }))
    const newEditorState = EditorUtils.createLinkAtSelection(editorState2, url)

    updateEditorState(newEditorState)
  }

  isValid = () => {
    const { linkText, url } = this.state

    return !(!isUrlValid(url) || linkText.length < 1)
  }

  onUrlChange = ({ target: { value } }) => {
    this.setState({ url: this.formatLink(value) })
  }

  onLinkTextChange = ({ target: { value } }) => {
    this.setState({ linkText: value })
  }

  onSubmit = () => {
    const { toggleModal } = this.props
    this.onLinkCreate()

    toggleModal()
  }

  render() {
    const { url, linkText } = this.state
    const { toggleModal } = this.props
    return (
      <Container>
        <CloseButton onClick={toggleModal}>
          <CloseIcon />
        </CloseButton>
        <Title>Insert Link</Title>
        <Row>
          <Input
            type="text"
            onChange={this.onLinkTextChange}
            value={linkText}
          />
        </Row>
        <Row>
          <Input
            type="text"
            onChange={this.onUrlChange}
            value={url}
          />
        </Row>
        <Buttons>
          <Cancel onClick={toggleModal}>
            Cancel
          </Cancel>
          <BlueLoadingButton disabled={!this.isValid()} type="button" onClick={this.onSubmit}>
            OK
          </BlueLoadingButton>
        </Buttons>
      </Container>
    )
  }
}
